import { get } from 'jquery';
import createAPI from '../axios'

// 系统管理相关 API
const system = {
    // 用户基本权限
    basic: {
        userMenu: config => createAPI('/admin/user/menu', 'post', config),
        userInfo: config => createAPI('/admin/user/info', 'post', config),
        userLogin: config => createAPI('/admin/user/login', 'post', config),
        changePwd: config => createAPI('/admin/user/change-pwd', 'post', config),
        oaLogin: config => createAPI('/admin/auth/auth', 'get', config),
    },
    // 菜单管理
    menu: {
        map: config => createAPI('/admin/menu/father-menus', 'post', config),
        list: config => createAPI('/admin/menu/list', 'post', config),
        save: config => createAPI('/admin/menu/save', 'post', config),
        delete: config => createAPI('/admin/menu/delete', 'post', config),
    },
    // 角色管理
    role: {
        list: config => createAPI('/admin/role/list', 'post', config),
        save: config => createAPI('/admin/role/save', 'post', config),
        delete: config => createAPI('/admin/role/delete', 'post', config),
        getMenu: config => createAPI('/admin/role/get-menu', 'post', config),
        getUser: config => createAPI('/admin/role/get-user-list', 'post', config),
        saveUser: config => createAPI('/admin/role/save-user-to-role', 'post', config),
        savePrivilege: config => createAPI('/admin/role/save-privilege', 'post', config),
    },
    // 用户管理
    user: {
        list: config => createAPI('/admin/user/list', 'post', config),
        save: config => createAPI('/admin/user/save', 'post', config),
        delete: config => createAPI('/admin/user/delete', 'post', config),
        resetPwd: config => createAPI('/admin/user/reset-pwd', 'post', config),
        getReportPermission: config => createAPI('/admin/user/get-report-permission', 'post', config),
        saveReportPermission: config => createAPI('/admin/user/save-report-permission', 'post', config),
    },
};

export default system;



// WEBPACK FOOTER //
// ./src/api/modules/system.js